<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-header">
            <h5>Ausstattungen</h5>
          </div>
          <div class="card-body">
            <b-row>
              <b-col md="12" class="list_mode iam-table-ux">
                <b-input-group class="datatable-btn">
                  <div class="input-group">
                    <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.ausstattung" placeholder="Suchen"></b-form-input>
                  </div>
                </b-input-group>
              </b-col>
            </b-row>
            <div class="table-responsive datatable-vue">
              <b-table
                show-empty
                :items="ausstattung"
                :filtered="onFilteredAusstattung"
                :current-page="tbl_currentPage.ausstattung"
                :filter="tbl_filter.ausstattung"
                :per-page="tbl_perPage.ausstattung"
                :fields="tbl_fields.ausstattung"
              >
                <template slot="empty"><div class="text-center">Keine Ausstattungselemente definiert.</div></template>
                <template v-slot:cell(actions)="row">
                  <feather
                    type="trash"
                    @click="deleteAusstattung(row.item.id)"
                    :id="'remove_ausstattung_admin_' + row.item.id"
                    class="infra-blue pointer"
                  ></feather>
                  <b-tooltip :target="'remove_ausstattung_admin_' + row.item.id" triggers="hover" placement="left">Ausstattung löschen.</b-tooltip>
                  <feather
                    type="edit-2"
                    :id="'edit_ausstattung_' + row.item.id"
                    class="infra-blue pointer"
                    @click="openModalAusstattung('edit', row.item)"
                  ></feather>
                  <b-tooltip :target="'edit_ausstattung_' + row.item.id" triggers="hover" placement="left">Ausstattung editieren</b-tooltip>
                </template>
                <template v-slot:cell(beschreibung)="row">
                  {{ truncate_str(row.item.beschreibung, 100) }}
                </template>
              </b-table>
            </div>
            <b-col>
              <div class="tbl-bottom-bar">
                <div class="pagination-container">
                  <b-pagination
                    v-if="tbl_totalRows.ausstattung > tbl_perPage.ausstattung"
                    v-model="tbl_currentPage.ausstattung"
                    :total-rows="tbl_totalRows.ausstattung"
                    :per-page="tbl_perPage.ausstattung"
                    class="my-0"
                  ></b-pagination>
                </div>
                <div class="button-container">
                  <b-button class="btn btn-primary" style="margin-right:10px;" @click="openModalKategorie()">Kategorien bearbeiten</b-button>
                  <b-button class="btn btn-primary" @click="openModalAusstattung('create')">Ausstattung hinzufügen</b-button>
                </div>
              </div>
            </b-col>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal_kategorien" ok-only size="lg" @hide="resetModalKategorien">
      <b-tabs v-model="tabs.kategorien.active">
        <b-tab title="Kategorien">
          <b-row style="margin-top:20px;">
            <b-col md="12" class="list_mode iam-table-ux">
              <b-input-group class="datatable-btn">
                <div class="input-group">
                  <b-form-input style="border:1px solid lightgrey" v-model="tbl_filter.kategorien" placeholder="Suchen"></b-form-input>
                </div>
              </b-input-group>
            </b-col>
          </b-row>
          <div class="table-responsive datatable-vue">
            <b-table
              show-empty
              :items="kategorien"
              :filtered="onFilteredKategorien"
              :current-page="tbl_currentPage.kategorien"
              :filter="tbl_filter.kategorien"
              :per-page="tbl_perPage.kategorien"
              :fields="tbl_fields.kategorien"
            >
              <template slot="empty"><div class="text-center">Keine Ausstattungselemente definiert.</div></template>
              <template v-slot:cell(actions)="row">
                <feather
                  :id="'delete_category_' + row.item.id"
                  type="trash"
                  class="infra-blue pointer"
                  @click="deleteCategory(row.item.id)"
                ></feather>
                <b-tooltip :target="'delete_category_' + row.item.id" triggers="hover" placement="left">Löschen</b-tooltip>
              </template>
            </b-table>
            <div class="pagination-container" style="margin-top:20px;">
              <b-pagination
                v-model="tbl_currentPage.kategorien"
                :total-rows="tbl_totalRows.kategorien"
                :per-page="tbl_perPage.kategorien"
                class="my-0"
              ></b-pagination>
            </div>
          </div>
        </b-tab>
        <b-tab title="Neue Kategorie">
          <div class="form-fields" style="margin-top:10px;" ref="test_ref">
            <label>Bezeichnung</label>&nbsp;
            <div class="red inline-block" v-if="hasError('kategorie_name')">
              - mindestens {{ validation.ausstattung_kategorien.name.minlength }} Zeichen.
            </div>
            <b-input-group prepend="Abc" class="form-input-group">
              <b-form-input v-model="modal.kategorien.name" v-bind:class="{ form_error: hasError('kategorie_name') }"></b-form-input>
            </b-input-group>
            <label>Beschreibung</label>&nbsp;
            <b-input-group prepend="Abc" class="form-input-group">
              <b-textarea v-model="modal.kategorien.beschreibung" rows="5"></b-textarea>
            </b-input-group>
          </div>
          <b-button @click="validateCategory">Hinzufügen</b-button>
        </b-tab>
      </b-tabs>
      <template slot="modal-header"><h4>Kategorien bearbeiten</h4></template>
    </b-modal>
    <b-modal id="modal_add_ausstattung" size="lg" ok-only @hide="resetModalAusstattung" no-close-on-backdrop>
      <template slot="modal-header"><h4>Ausstattung hinzufügen</h4></template>
      <div><h6>Bild hinzufügen</h6></div>
      <div class="upload-dropzone" style="margin-bottom:10px;margin-top:10px;">
        <dropzone
          ref="ausstattung_dropzone"
          id="ausstattung_dropzone"
          class="ausstattung-dropzone"
          :options="dropzone.ausstattung.options"
          v-on:vdropzone-success="processNewAusstattung"
          v-on:vdropzone-file-added="dropzone.ausstattung.file = true"
          v-on:vdropzone-removed-file="dropzone.ausstattung.file = false"
        ></dropzone>
      </div>
      <div class="form-fields">
        <label>Name</label>
        <div class="red inline-block" v-if="hasError('ausstattung_name')">- mindestens {{ validation.ausstattung.name.minlength }} Zeichen.</div>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.ausstattung.name" v-bind:class="{ form_error: hasError('ausstattung_name') }"></b-form-input>
        </b-input-group>
        <label>Beschreibung</label>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-textarea v-model="modal.ausstattung.beschreibung" rows="5"></b-textarea>
        </b-input-group>
        <label>Kategorie</label>
        <b-input-group class="form-input-group">
          <b-form-select
            v-model="modal.ausstattung.kategorie"
            :options="kategorie_options"
            name="category"
            v-bind:class="{ form_error: hasError('ausstattung_kategorie') }"
          ></b-form-select>
        </b-input-group>

        <div class="ausstattung-properties-container">
          <div class="ausstattung-properties-head">
            <h6 style="display:inline-block">
              Ausstattungseigenschaften<feather
                id="addPropTooltip"
                size="20"
                type="help-circle"
                class="infra-blue pointer"
                style="vertical-align:middle;margin-left:10px;"
              ></feather
              ><b-tooltip target="addPropTooltip" placement="left">Benutzen Sie das + Icon um der Ausstattung Eigenschaften hinzuzufügen.</b-tooltip>
            </h6>
            <div class="ausstattung-properties-buttons">
              <feather id="addPropButton" type="plus" @click="addProp()" class="icon-button"></feather>
              <b-tooltip target="addPropButton" triggers="hover" placement="left">Neues Merkmal hinzufügen</b-tooltip>
            </div>
          </div>
          <hr />
          <!-- TODO: this is not working correctly bc properties is given as a string-->
          <div class="ausstattung-properties-items" v-if="modal.ausstattung.properties.length">
            <b-input-group v-for="(prop, index) in modal.ausstattung.properties" :key="'prop_' + index">
              <b-form-input v-model="modal.ausstattung.properties[index].name" placeholder="Name..."></b-form-input>
              <b-form-input v-model="modal.ausstattung.properties[index].value" placeholder="Wert..."></b-form-input>
              <div class="remove-prop-container">
                <feather :id="'removePropButton_' + index" type="minus" @click="removeProp(index)" class="icon-button minus-button"></feather>
                <b-tooltip :target="'removePropButton_' + index" triggers="hover" placement="left">Merkmal entfernen</b-tooltip>
              </div>
            </b-input-group>
          </div>
        </div>
      </div>
      <div class="button-container-ausstattung">
        <b-button class="btn btn-primary" style="width:100%;" v-if="modal.mode.ausstattung == 'create'" @click="validateAusstattung"
          >Ausstattung hinzufügen</b-button
        >
        <b-button class="btn btn-primary" style="width:100%;" v-if="modal.mode.ausstattung == 'edit'" @click="editAusstattung"
          >Ausstattung speichern</b-button
        >
        <Loader v-if="updating.ausstattung" />
      </div>
      <template slot="modal-ok">Schließen</template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vue2Dropzone from "vue2-dropzone";
import LoaderRelative from "@/components/LoaderRelative.vue";

export default {
  name: "AdminAusstattungen",
  components: {
    dropzone: vue2Dropzone,
    Loader: LoaderRelative,
  },
  data() {
    return {
      validation_errors: [],
      tbl_fields: {
        ausstattung: [
          { key: "name", label: "Name", sortable: true },
          { key: "kategorie.name", label: "Kategorie", sortable: true },
          { key: "beschreibung", label: "Beschreibung", sortable: false },
          { key: "actions", label: "Aktionen", sortable: false },
        ],
        kategorien: [
          { key: "name", label: "Name", sortable: true },
          { key: "beschreibung", label: "Beschreibung", sortable: false },
          { key: "actions", label: "", sortable: false },
        ],
      },
      tbl_filter: {
        ausstattung: null,
        kategorien: null,
      },
      tbl_currentPage: {
        ausstattung: 1,
        kategorien: 1,
      },
      tbl_perPage: {
        ausstattung: 10,
        kategorien: 10,
      },
      tbl_totalRows: {
        ausstattung: 1,
        kategorien: 1,
      },
      modal: {
        mode: {
          ausstattung: null,
        },
        ausstattung: {
          name: "",
          beschreibung: "",
          kategorie: "default",
          properties: [],
        },
        kategorien: {
          name: "",
          beschreibung: "",
        },
        edit_ausstattung: {},
      },
      tabs: {
        kategorien: {
          active: 0,
        },
      },
      dropzone: {
        ausstattung: {
          file: false,
          options: false,
        },
      },
      updating: {
        ausstattung: false,
        kategorien: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      animations: "app/animations",
      toasts: "app/toasts",
      user: "auth/user",
      kategorien: "fitting/kategorien",
      ausstattung: "fitting/ausstattung",
      validation: "app/validation",
      api: "auth/apiSettings",
    }),
    kategorie_options() {
      let options = this.kategorien.map((c) => {
        return { value: c.id, text: c.name };
      });
      options.unshift({ value: "default", text: "Bitte wählen", disabled: true });
      return options;
    },
  },
  async created() {
    await this.init();
  },
  methods: {
    async deleteAusstattung(ausId) {
      try {
        await this.$store.dispatch("fitting/deleteAusstattung", ausId);
        await this.$store.dispatch("fitting/getAusstattung");
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async startUpload() {
      if (this.dropzone.ausstattung.file) {
        this.$refs.ausstattung_dropzone.processQueue();
      } else {
        const payload = this.modal.ausstattung;
        await this.createAusstattung(payload);
      }
    },
    async processNewAusstattung(upload, responseDirectus) {
      const payload = { ...this.modal.ausstattung, image: responseDirectus.data.id };
      await this.createAusstattung(payload);
    },
    async createAusstattung(payload) {
      this.updating.ausstattung = true;
      try {
        await this.$store.dispatch("fitting/createAusstattung", payload);
        await this.$store.dispatch("fitting/getAusstattung");
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.updating.ausstattung = false;
        this.closeModalAusstattung();
      }
    },
    addProp() {
      const emptyProp = {
        name: "",
        value: "",
      };
      this.modal.ausstattung.properties.push(emptyProp);
    },
    removeProp(index) {
      this.modal.ausstattung.properties.splice(index, 1);
    },
    resetModalAusstattung() {
      this.validation_errors = [];
      this.modal.ausstattung = {
        name: "",
        beschreibung: "",
        kategorie: "default",
        properties: [],
      };
    },
    resetModalKategorien() {
      this.validation_errors = [];
      this.modal.kategorien = {
        name: "",
        beschreibung: "",
      };
    },
    async validateAusstattung() {
      this.validation_errors = [];
      const fields = ["name"];

      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", {
            context: "ausstattung",
            field,
            value: this.modal.ausstattung[field],
          });

          if (!result) this.validation_errors.push("ausstattung_" + field);
        })
      );

      if (this.modal.ausstattung.kategorie == "default") this.validation_errors.push("ausstattung_kategorie");
      if (this.validation_errors.length) return;

      await this.startUpload();
    },
    async deleteCategory(catId) {
      try {
        await this.$store.dispatch("fitting/deleteCategory", catId);
      } catch (error) {
        this.$toasted.show(error, this.toasts.failure);
      }
    },
    async validateCategory() {
      this.validation_errors = [];
      const fields = ["name"];

      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", {
            context: "ausstattung_kategorien",
            field,
            value: this.modal.kategorien[field],
          });

          if (!result) this.validation_errors.push("kategorie_" + field);
        })
      );

      if (this.validation_errors.length) return;
      await this.createNewCategory();
    },
    async createNewCategory() {
      try {
        await this.$store.dispatch("fitting/createCategory", this.modal.kategorien);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.tabs.kategorien.active = 0;
        this.modal.kategorien = {
          name: "",
          beschreibung: "",
        };
      }
    },
    hasError(field) {
      return this.validation_errors.indexOf(field) > -1 ? true : false;
    },
    async editAusstattung() {
      try {
        const mutationPayload = {
          collection: "ausstattung",
          item: this.modal.ausstattung.id,
          changes: {
            name: this.modal.ausstattung.name,
            kategorie: this.modal.ausstattung.kategorie.id,
            properties: this.modal.ausstattung.properties, //TODO: maybe needs to change sth here..
            image: this.modal.ausstattung.image.id,
            beschreibung: this.modal.ausstattung.beschreibung,
          },
        };
        await this.$store.dispatch("app/mutate", mutationPayload);
      } catch(error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
                await this.$store.dispatch("fitting/getAusstattung");

        this.$bvModal.hide("modal_add_ausstattung");
      }
    },
    openModalKategorie() {
      this.$bvModal.show("modal_kategorien");
    },
    closeModalKategorie() {
      this.$bvModal.hide("modal_kategorie");
    },
    openModalAusstattung(mode = "create", ausstattung = null) {
      this.modal.mode.ausstattung = mode;
      if (mode == "create") this.$bvModal.show("modal_add_ausstattung");
      if (this.modal.mode.ausstattung == "edit") {
        this.modal.ausstattung = ausstattung;
        this.$bvModal.show("modal_add_ausstattung");
        const file = {
          size: this.modal.ausstattung.image.filesize,
          name: this.modal.ausstattung.image.title,
          type: this.modal.ausstattung.image.type,
        };
        this.$nextTick(() => this.$refs.ausstattung_dropzone.manuallyAddFile(file, this.modal.ausstattung.image.data.full_url));
      }
    },
    closeModalAusstattung() {
      this.$bvModal.hide("modal_add_ausstattung");
    },
    onFilteredAusstattung(filteredItems) {
      this.tbl_totalRows.ausstattung = filteredItems.length;
      this.tbl_currentPage.ausstattung = 1;
    },
    onFilteredKategorien(filteredItems) {
      this.tbl_totalRows.ausstattung = filteredItems.length;
      this.tbl_currentPage.ausstattung = 1;
    },

    async init() {
      this.dropzone.ausstattung.options = {
        url: this.api.customUploads,
        thumbnailMethod: "contain",
        thumbnailWidth: 500,
        maxFiles: 1,
        autoProcessQueue: false,
        init: function() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
        },
        dictDefaultMessage:
          '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline></svg>',

        headers: {
          Authorization: "bearer " +  await this.$directus.auth.token,
          "Cache-Control": null,
          "X-Requested-With": null,
        },
      };

      try {
        await this.$store.dispatch("fitting/getKategorien");
        await this.$store.dispatch("fitting/getAusstattung");
      } catch (error) {
        this.$toasted.show(error, this.toasts.failure);
      }
    },
  },
};
</script>

<style>
.icon-button {
  background: #004f7d;
  color: white;
  margin-left: 5px;
}

.icon-button:hover {
  background: white;
  color: #004f7d;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
</style>

<style scoped>
.tbl-bottom-bar {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.icon-button {
  background: #004f7d;
  color: white;
  margin-left: 5px;
}

.icon-button:hover {
  background: white;
  color: #004f7d;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}

.ausstattung-properties-container {
  margin-bottom: 15px;
}

.ausstattung-properties-head {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.ausstattung-properties-items input {
  padding: 5px;
  margin: 5px;
}

.remove-prop-container {
  display: flex;
  flex-flow: column;
  justify-content: center;
}

.button-container-ausstattung {
  display: flex;
  flex-flow: column;
  justify-content: center;
}
</style>
